module.exports = __webpack_public_path__ + "static/media/icon-checked.39d85c98.svg";